import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PAGE } from './routes';
import { GameId } from './common/model/game-id';

const routes: Routes = [
  {
    path: `${PAGE.LAUNCH_GAME}/:gameId`,
    loadChildren: () =>
      import('./features/game-iframe/game-iframe.module').then((m) => m.GameIframePageModule),
  },
  { path: '**', redirectTo: `${PAGE.LAUNCH_GAME}/${GameId.Solitaire}` },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
